interface Props {
  size?: number;
}

/**
 * BrassMonogram — the watchmaker's mark. Colors come from the CSS token
 * layer (--b-*, --ast-recovery); no raw hex in this primitive (S6).
 */
export default function BrassMonogram({ size = 32 }: Props) {
  return (
    <svg width={size} height={size} viewBox="-50 -50 100 100" aria-hidden="true">
      <defs>
        <linearGradient id="bm" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: "var(--b-100)" }} />
          <stop offset="60%" style={{ stopColor: "var(--ast-recovery)" }} />
          <stop offset="100%" style={{ stopColor: "var(--b-700)" }} />
        </linearGradient>
      </defs>
      <circle r="46" fill="none" stroke="url(#bm)" strokeWidth="1.5" />
      <circle r="40" fill="none" style={{ stroke: "var(--b-700)" }} strokeWidth="0.5" />
      {Array.from({ length: 12 }, (_, i) => i).map((i) => {
        const a = ((i * 30 - 90) * Math.PI) / 180;
        return (
          <line
            key={i}
            x1={36 * Math.cos(a)}
            y1={36 * Math.sin(a)}
            x2={42 * Math.cos(a)}
            y2={42 * Math.sin(a)}
            style={{ stroke: "var(--ast-recovery)" }}
            strokeWidth="1"
          />
        );
      })}
      <text
        x="0"
        y="0"
        textAnchor="middle"
        dominantBaseline="central"
        fontFamily="Cormorant Garamond, serif"
        fontStyle="italic"
        fontSize="36"
        fill="url(#bm)"
      >
        A
      </text>
    </svg>
  );
}
